import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './Banner';
import VideoBox from './VideoBox';
import Vote from './Vote';
import VideoGags from './VideoGags';
import DramaGags from './DramaGags';
import Relate from './Relate';
import Brand from './Brand';
import Company from './Company';
import Thank from './Thank';
import Comment from './Comment';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout}>
            {/* 顶部轮播图 */}
            <Banner content={content.bannerData} />
            {/* 年度人物视频专区 */}
            {content?.videoBoxTitleImage?.imageUrl ? <VideoBox videoBoxTitleImage={content.videoBoxTitleImage.imageUrl} content={content.videoBoxData} /> : null}
            {/* 票数排行榜 */}
            {content?.voteTitleImage?.imageUrl ? <Vote surveyData={content.surveyData} videoBoxData={content.videoBoxData} voteTitleImage={content.voteTitleImage.imageUrl} /> : null}
            {/* 视频花絮专区 */}
            {content?.videoGagsImage?.imageUrl ? <VideoGags videoGagsImage={content.videoGagsImage.imageUrl} content={content.videoGagsData} /> : null}
            {/* 剧照花絮专区 */}
            {content?.dramaGagsTitleImage?.imageUrl ? <DramaGags dramaGagsTitleImage={content.dramaGagsTitleImage.imageUrl} content={content.dramaGagsData} /> : null}
            {/* 相关报道 */}
            {content?.relateTitleImage?.imageUrl ? <Relate relateTitleImage={content.relateTitleImage.imageUrl} content={content.relateData} /> : null}
            {/* 品牌广告 */}
            {content?.brandData?.imageUrl ? <Brand content={content.brandData} /> : null}
            {/* 企业专区 */}
            {content?.companyTitleImage?.imageUrl ? <Company companyTitleImage={content.companyTitleImage.imageUrl} content={content.companyData} /> : null}
            {/* 特别鸣谢 */}
            {content?.thankTitleImage?.imageUrl ? <Thank thankTitleImage={content.thankTitleImage.imageUrl} /> : null}
            {/* 评论专区 */}
            {content?.commentTitleImage?.imageUrl ? <Comment content={content.commentData} commentTitleImage={content.commentTitleImage.imageUrl} /> : null}
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
